import React, { useEffect } from "react";
import { useDeviceStore } from "../../../stores/useDeviceStore";
import { MOBILE_BREAKPOINT } from "../../../constants";

function SyncDevice() {
  const setIsMobile = useDeviceStore((state) => state.setIsMobile);

  useEffect(() => {
    const syncIsMobile = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    syncIsMobile();
    window.addEventListener("resize", syncIsMobile);

    return () => window.removeEventListener("resize", syncIsMobile);
  }, [setIsMobile]);

  return null;
}

export default SyncDevice;
